module.exports = __webpack_public_path__ + "533be153f44dfeccc420e0a6df799101.png";